/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as i from "react";
import e from "prop-types";
const r = class r extends i.Component {
  /**
   * @hidden
   */
  render() {
    return null;
  }
};
r.propTypes = {
  text: e.string,
  icon: e.string,
  iconClass: e.string,
  imageUrl: e.string,
  selected: e.bool,
  disabled: e.bool,
  render: e.any
};
let s = r;
export {
  s as DropDownButtonItem
};
